<template>
  <div class="flex block px-4 py-3">
    <div>
      <img class="w-12 h-12" :src="item.thumbnail" alt="">
    </div>
    <div class="flex flex-col items-start ml-4 leading-tight">
      <span class="font-bold">{{ item.title }}</span>
      <span
        class="mt-1 tracking-wide text-xs py-1 px-2 rounded border leading-none"
        :class="{'bg-blue-100 text-blue-500 border-blue-300': scrapie, 'bg-gray-200 text-gray-500 border-gray-400': !scrapie}">
        {{ (!scrapie ? 'Not ' : '') + 'Scrapie Approved' }}
      </span>
      <span class="text-sm text-gray-800 mt-1">
        <span v-html="formattedPrice(item.price)"></span>
      </span>
    </div>
  </div>
</template>

<script>
import { formattedPrice } from '../helpers.js';

export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          price: ["0.00"],
          thumbnail: "",
          title: "",
        };
      },
    },
  },

  computed: {
    scrapie() {
      return this.item.scrapie.includes('Yes');
    },
  },

  methods: {
    formattedPrice,
  },
}
</script>
